import { NoAccess } from 'app/components'

export interface AccessBannerProps {
  userType: 'fresher' | 'student' | string
  allowedUserTypes: string[]
  isMember: boolean
  isPrivate: boolean
}

export const AccessBanner = (props: AccessBannerProps) => {
  // If the group is private and the user is not a member then they are not
  // allowed to access the group.
  if (props.isPrivate && !props.isMember) {
    return (
      <NoAccess
        hideSignUp
        title="This is a private Group. Only accepted members can post content."
        description="But don’t worry, hit join and an admin will accept or decline your request as soon as possible!"
      />
    )
  }

  // If only students are allowed to access the group then we need to make sure
  // that the user has verified their email address.
  if (props.userType !== 'student' && !props.isMember && props.allowedUserTypes.includes('student')) {
    return (
      <NoAccess
        hideSignUp
        verifyEmail
        title={
          props.isPrivate
            ? 'You need to verify your university email address to request access to this group.'
            : 'You need to verify your university email address to join this group.'
        }
        description={
          props.isPrivate
            ? 'This is a private group. Once verified, you can request access to join.'
            : 'This is a Public group. Please verify your email to gain full access.'
        }
      />
    )
  }

  // If the user is a fresher and the group allows freshers then they are allowed
  // to access the group, but they need to be a member
  if (props.userType === 'fresher' && !props.isMember && props.allowedUserTypes.includes('fresher')) {
    return (
      <NoAccess
        hideSignUp
        verifyEmail
        title={
          props.isPrivate
            ? 'You need to verify your university email address to request access to this group.'
            : 'You need to verify your university email address to join this group.'
        }
        description={
          props.isPrivate
            ? 'This is a private group. Once verified, you can request access to join.'
            : 'This is a Public group. Please verify your email to gain full access.'
        }
      />
    )
  }

  // If the user is not one of the allowed types then they are not allowed
  // to access the group.
  if (!props.allowedUserTypes.includes(props.userType)) {
    return (
      <NoAccess
        hideSignUp
        title="You are not allowed to post to this group."
        description={`This group is only available to ${props.allowedUserTypes.join('s and ')}s`}
      />
    )
  }


  return null
}
